import { applyComponentTheme } from '../../theme';
import TableCell from './TableCell';
import { Table } from './styles';

export { TableCell };
export default applyComponentTheme(Table, 'Table');
